import lottie from 'lottie-web';
const pageLoader = document.querySelector('[data-loader]');
const lottieElement = document.querySelector('[data-loader-lottie]');
const init = () => {
    if (lottieElement) {
        const jsonPath = lottieElement.getAttribute('data-json');
        lottieElement.removeAttribute('data-json');
        lottie.loadAnimation({
            container: lottieElement,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: jsonPath,
        });
    }
};
const show = () => {
    if (pageLoader) {
        pageLoader.classList.add('show');
    }
};
const hide = () => {
    if (pageLoader) {
        pageLoader.classList.remove('show');
    }
};
export default {
    init,
    show,
    hide,
};
